import { computed, ref } from 'vue';
import { useLocationsStore } from '@/stores/locations';
import { useResourcesStore } from '@/stores/resources';
import { useServicesStore } from '@/stores/services';

const selectedLocationIds = ref<number[]>([]);
const locationOptions = computed(() => {
  const { locations } = useLocationsStore();

  return locations.map((location) => ({
    value: location.id,
    label: location.internalName,
  }));
});

const selectedServiceIds = ref<number[]>([]);
const serviceOptions = computed(() => {
  const { categoriesWithServices } = useServicesStore();
  const _categoriesWithServices = categoriesWithServices.filter(
    (category) => category.services.length,
  );
  return _categoriesWithServices.length
    ? _categoriesWithServices.map((category) => ({
        label: category.name,
        color: category.color,
        items: category.services.map((service) => ({
          label: service.name,
          id: service.id,
        })),
      }))
    : [];
});

const selectedEmployeeIds = ref<number[]>([]);
const employeeOptions = computed(() => {
  const { employees } = useResourcesStore();
  return employees.map((employee) => ({
    label: employee.name,
    color: employee.color,
    id: employee.id,
  }));
});

const selectedShareOption = ref('link');

export default {
  selectedLocationIds,
  locationOptions,
  selectedServiceIds,
  serviceOptions,
  selectedEmployeeIds,
  employeeOptions,
  selectedShareOption,
};
